import { useState } from "react";
import { useT } from "../i18n/hooks.ts";
import { Dialog } from "./Dialog.tsx";

/** Generic dialog to rename something (currently only a saved project, see Landing.tsx) — same pattern as the rest of the edit dialogs. */
export function RenameDialog({
  title,
  initialName,
  onSave,
  onClose,
}: {
  title: string;
  initialName: string;
  onSave: (name: string) => void;
  onClose: () => void;
}) {
  const t = useT();
  const [name, setName] = useState(initialName);
  const [error, setError] = useState<string | null>(null);

  function save() {
    const cleanName = name.trim();
    if (!cleanName) {
      setError(t("common.emptyName"));
      return;
    }
    onSave(cleanName);
  }

  return (
    <Dialog title={title} onClose={onClose}>
      <div className="step-form">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && save()}
          autoFocus
        />
        {error && <p className="error">{error}</p>}
        <button className="button button-primary" onClick={save}>
          {t("common.save")}
        </button>
        <button className="button" onClick={onClose}>
          {t("common.cancel")}
        </button>
      </div>
    </Dialog>
  );
}
